import { NubVisionAppsRepository } from "../../../../data/repository/nubVisionApps/NubVisionAppsRepository";
import { Message } from "../../../model/Auth";
import { NubVisionApp } from "../../../model/NubVisionApp";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetAllNubVisionAppsUseCase {
  invoke: () => Promise<ResponseState<Array<NubVisionApp>>>;
}

export class GetAllNubVisionAppsUseCaseImpl
  implements GetAllNubVisionAppsUseCase
{
  private nubVisionAppsRepository: NubVisionAppsRepository;

  constructor(nubVisionAppsRepository: NubVisionAppsRepository) {
    this.nubVisionAppsRepository = nubVisionAppsRepository;
  }

  async invoke(): Promise<ResponseState<Array<NubVisionApp>>> {
    try {
      let response = await this.nubVisionAppsRepository.getAll();
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
